import { HTMLAttributes, PropsWithChildren } from 'react';

type Props = Omit<PropsWithChildren<HTMLAttributes<HTMLDivElement>>, 'className'>;
function Wrapper(props: Props) {
  return <div className="p-2 d-flex flex-column h-100 overflow-y-auto gap-2" {...props} />;
}

function Block(props: Props) {
  return <div className="d-flex flex-column bg-light bg-opacity-10 p-4 gap-2" {...props} />;
}

function Body(props: Props) {
  return <div className="d-flex flex-column flex-grow-1 gap-3 overflow-y-auto" {...props} />;
}

function Row(props: Props) {
  return <div className="row m-0 gx-3" {...props} />;
}

export const Layout = {
  Wrapper,
  Block,
  Body,
  Row,
};
